/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
window.PXUTheme.jsCollectionList = {
  init: function ($section) {
    window.PXUTheme.jsCollectionList = $.extend(this, window.PXUTheme.getSectionData($section));

    if (this.use_mobile_slider) {
      this.createSlider($section);
    }
  },
  createSlider: function ($section) {
    const $prevButton = $section.find('.collection-list__nav--prev');
    const $nextButton = $section.find('.collection-list__nav--next');
    const $collectionListSlider = $section.find('[data-collection-list-wrapper]');
    const mobileColumns = parseInt($collectionListSlider.data('mobile-columns'), 10) || 1;
    const hasMultipleMobileColumns = mobileColumns > 1;

    if ($collectionListSlider.hasClass('flickity-enabled')) {
      $collectionListSlider.flickity('destroy');
    }

    const $flickitySlider = $collectionListSlider.flickity({
      initialIndex: 0,
      prevNextButtons: false,
      wrapAround: !hasMultipleMobileColumns,
      pageDots: this.show_navigation_dots,
      watchCSS: true,
      imagesLoaded: true,
      adaptiveHeight: !hasMultipleMobileColumns,
      cellAlign: hasMultipleMobileColumns ? 'left' : 'center',
      contain: hasMultipleMobileColumns,
      groupCells: hasMultipleMobileColumns ? '100%' : false,
    });

    $flickitySlider.on('settle.flickity', () => $flickitySlider.flickity('resize'));
    $prevButton.off('click.collectionList').on('click.collectionList', () => $flickitySlider.flickity('previous'));
    $nextButton.off('click.collectionList').on('click.collectionList', () => $flickitySlider.flickity('next'));
  },
  unload($section) {
    const $slider = $section.find('.flickity-enabled');
    if ($slider.length) {
      $slider.flickity('destroy');
    }
    $section.find('.collection-list__nav--prev').off('click.collectionList');
    $section.find('.collection-list__nav--next').off('click.collectionList');
  },
};

/******/ })()
;
